import { eventReports } from "./event-reports";

export const event = {
	...eventReports,
};
